<script lang="ts">
  import Header from "../Header.svelte";
  import TopBar from "../TopBar.svelte";
  import { isPlugin } from "state/app";

  const embedded = isPlugin;
</script>

<div class="top">
  {#if embedded}
    <TopBar authenticated={false} />
  {:else}
    <Header />
  {/if}
</div>
<div class="wrapper">
  <slot />
</div>

<style>
  .wrapper {
    padding: var(--org-medium);
  }
</style>
